import { render, staticRenderFns } from "./GlobalLayout.vue?vue&type=template&id=879cd420&scoped=true"
import script from "./GlobalLayout.vue?vue&type=script&lang=js"
export * from "./GlobalLayout.vue?vue&type=script&lang=js"
import style0 from "./GlobalLayout.vue?vue&type=style&index=0&id=879cd420&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879cd420",
  null
  
)

export default component.exports